import React from "react";
import { Opportunity, ValidationStatus } from "../../helpers/shared-interfaces";
import { Progress, Col, Row, List } from "antd";
import cancelIcon from "../../images/cancel.svg";
import acceptIcon from "../../images/accept.svg";

export function generateIcon(status: boolean): JSX.Element {
  return status ? (
    <img
      className="validation-status-icon"
      id="accept-icon"
      src={acceptIcon}
      alt="fb-icon"
    />
  ) : (
    <img
      className="validation-status-icon"
      id="cancel-icon"
      src={cancelIcon}
      alt="fb-icon"
    />
  );
}

interface Props {
  id?: string;
  opportunity: Opportunity;
  results: ValidationStatus[];
  percentage: number;
}

export function renderListItem(result: ValidationStatus): JSX.Element {
  return (
    <List.Item>
      <Row
        style={{
          width: "100%",
        }}
      >
        <Col span={14}>
          <h4 style={{ position: "relative", top: "4px" }}>{result.message}</h4>
        </Col>
        <Col
          style={{
            textAlign: "right",
          }}
          span={10}
        >
          {generateIcon(result.status)}
        </Col>
      </Row>
    </List.Item>
  );
}

export default class CheckList extends React.Component<
  Props,
  Record<string, unknown>
> {
  render(): JSX.Element {
    return (
      <div>
        {
          <div
            className="progress-bar-container"
            style={{ marginBottom: "5px" }}
          >
            <Progress
              strokeColor={
                this.props.percentage === 100 ? "#52c41a" : "rgb(29, 55, 100)"
              }
              style={{ marginBottom: "10px" }}
              percent={this.props.percentage}
            />
          </div>
        }
        {
          <List
            id="onboarding-checklist"
            style={{ width: "100%" }}
            size="large"
            header={null}
            footer={null}
            bordered
            dataSource={this.props.results}
            renderItem={renderListItem}
          />
        }
      </div>
    );
  }
}
